import React from "react";
import config from "Config";

export const HelpVideoLinks = () => (
  <React.Fragment>
    <ul className="list-inline d-flex mb-0">
      <li className="list-inline-item">
        <a
          className="btn btn-sm btn-info"
          target="_blank"
          rel="noopener"
          href={config.quick_guide_link}
        >
          <i className="fa fa-file-pdf-o"></i> Quick Guide
        </a>
      </li>
      <li className="list-inline-item">
        <a
          className="btn btn-sm btn-info"
          target="_blank"
          rel="noopener"
          href={config.video_link_about_this_site}
        >
          <i className="fa fa-video-camera"></i> About this website
        </a>
      </li>
      <li className="list-inline-item">
        <a
          className="btn btn-sm btn-info"
          target="_blank"
          rel="noopener"
          href={config.video_link_how_to_find_area_profile}
        >
          <i className="fa fa-video-camera"></i> How To: Find an Area Profile
        </a>
      </li>
      <li className="list-inline-item">
        <a
          className="btn btn-sm btn-info"
          target="_blank"
          rel="noopener"
          href={config.video_link_how_to_find_community_profile}
        >
          <i className="fa fa-video-camera"></i> How To: Find a Community
          Profile
        </a>
      </li>
    </ul>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./components/Common.js